import { Endpoint } from '../endpoint';
import { FeeNoteId, TimeMaterialFeeNotesResponse, TMFeeId } from '@business/entities/tm';

// Notes on a work order's fee (Summary tab notes icon), the same as the category notes (tm_group_notes)
export function fetchFeeNotes(feeId: TMFeeId) {
  return Endpoint.get<TimeMaterialFeeNotesResponse[]>(`@gc/tm-fee-notes/${feeId}`);
}

export function createFeeNote(feeId: TMFeeId, note: string) {
  return Endpoint.post<TimeMaterialFeeNotesResponse>(`@gc/tm-fee-notes/${feeId}`, { data: { note } });
}

export function updateFeeNote(noteId: FeeNoteId, note: string) {
  return Endpoint.patch<TimeMaterialFeeNotesResponse>(`@gc/tm-fee-notes/${noteId}`, { data: { note } });
}

export function deleteFeeNote(noteId: FeeNoteId) {
  return Endpoint.delete<void>(`@gc/tm-fee-notes/${noteId}`);
}
